import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { useGreenhouseQuery, WorkType } from "@faire/retailer-shared/greenhouse/departmentsRequest";
import { mapDepartmentsWithTieredView } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
export var useDepartments = function(strictLocalize) {
    var _useGreenhouseQuery = useGreenhouseQuery(WorkType.EMPLOYMENT), employmentData = _useGreenhouseQuery.data, employmentIsLoading = _useGreenhouseQuery.isPending, employmentIsError = _useGreenhouseQuery.isError;
    var _useGreenhouseQuery1 = useGreenhouseQuery(WorkType.CONSULTANT), consultantData = _useGreenhouseQuery1.data, consultantIsLoading = _useGreenhouseQuery1.isPending, consultantIsError = _useGreenhouseQuery1.isError;
    var consultantDepartments = [];
    var employmentDepartments = [];
    if (!employmentIsLoading && !employmentIsError && employmentData) {
        employmentDepartments = mapDepartmentsWithTieredView(employmentData, strictLocalize);
    }
    if (!consultantIsLoading && !consultantIsError && consultantData) {
        consultantDepartments = mapDepartmentsWithTieredView(consultantData, strictLocalize);
    }
    var _obj;
    return _obj = {}, _define_property(_obj, WorkType.EMPLOYMENT, {
        departments: employmentDepartments,
        isLoading: employmentIsLoading,
        isError: employmentIsError
    }), _define_property(_obj, WorkType.CONSULTANT, {
        departments: consultantDepartments,
        isLoading: consultantIsLoading,
        isError: consultantIsError
    }), _obj;
};
